import { render, staticRenderFns } from "./ClockStart.vue?vue&type=template&id=2e26f571"
import script from "./ClockStart.vue?vue&type=script&lang=js"
export * from "./ClockStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports